<template>
    <bar :options="options" :data="data" />
</template>

<script lang="ts">
    import {Vue, Component, Prop} from 'vue-facing-decorator'
    import {Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale} from 'chart.js'
    import {Bar} from 'vue-chartjs'

    ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend)

    @Component({
        components: {
            Bar,
        },
    })
    export class BarChart extends Vue {
        @Prop({default: () => ({}), type: Object}) data

        options = {
            plugins: {
                legend: {
                    display: false,
                },
                tooltip: {
                    callbacks: {
                        label: context => this.getLabel(context.dataset.token, context.raw),
                        title: context => context[0].label,
                    },
                },
            },
            responsive: true,
            maintainAspectRatio: false,
        }

        getLabel(token, prop) {
            return this.$t(token, {prop})
        }
    }

    export default BarChart
</script>
